"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7569],{

/***/ 27569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ foodProgram_OurServices; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./public/artifacts/images/food-program-page/services/catering-person.webp
/* harmony default export */ var catering_person = ({"src":"/_next/static/media/catering-person.fc236701.webp","height":227,"width":240,"blurDataURL":"data:image/webp;base64,UklGRsAAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSEEAAAABYBPblpM/Wy8gIlMjAgM4wQeDBQYDDG0GLVRbkvNGERExAeDVB8l8MCZKKb3DmCqLUjXWqjxRReYsdQiCaiUpBgBWUDggWAAAALACAJ0BKggACAACQDglAE6QJjADWoAfoAdmc4IDgADiBNdMHKNQ9CmbzS5n9DchXRkwUZdgB7TYovR0uc76+E9uqv5jbdKGRHsUL3M5KMNKkXi3uzlgAAA=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/artifacts/images/food-program-page/services/notebook.webp
/* harmony default export */ var notebook = ({"src":"/_next/static/media/notebook.4c40672a.webp","height":227,"width":240,"blurDataURL":"data:image/webp;base64,UklGRrgAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSEEAAAABYBPblpM/Wy8gIlMjAgM4wQeDBQYDDG0GLVRbkvNGERExAeDVB8l8MCZKKb3DmCqLUjXWqjxRReYsdQiCaiUpBgBWUDggUAAAADACAJ0BKggACAACQDgljAJ0BMAH6AGooGYAAP5IBrQgXXRA87dfDGIUdeIcwyPwJhrOnuhvnnjJe7ci6fcc8jyX0eiARgaruMo04cSpPgAA","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/artifacts/images/food-program-page/services/smiling-person.webp
/* harmony default export */ var smiling_person = ({"src":"/_next/static/media/smiling-person.9c6ef5ba.webp","height":227,"width":240,"blurDataURL":"data:image/webp;base64,UklGRsQAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSEEAAAABYBPblpM/Wy8gIlMjAgM4wQeDBQYDDG0GLVRbkvNGERExAeDVB8l8MCZKKb3DmCqLUjXWqjxRReYsdQiCaiUpBgBWUDggXAAAAFACAJ0BKggACAACQDglAE6P4BHQC8AjnLgUAAD9/nv9XF9O4wPpRz9fecvK6bmiLzbiPXLTNMZJCZ762G8QXrSuEBfJp+Ki3OGxa21RKSmUUX+PaxzWRSWkAAAA","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./public/artifacts/images/homepage/redesign/check-icon.png
var check_icon = __webpack_require__(20775);
// EXTERNAL MODULE: ./src/shared/helpers/urls.ts
var urls = __webpack_require__(6880);
// EXTERNAL MODULE: ./src/static_pages/foodProgram/useFoodProgramCta.ts
var useFoodProgramCta = __webpack_require__(31006);
// EXTERNAL MODULE: ./src/static_pages/foodProgram/Utils.tsx
var Utils = __webpack_require__(54397);
// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/static_pages/foodProgram/OurServices.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  font-size: 16px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  gap: ",
        "px;\n\n  ",
        " {\n    gap: ",
        "px;\n  }\n\n  ",
        " {\n    gap: ",
        "px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  flex-shrink: 0;\n  height: revert;\n  width: 305px;\n  max-width: 400px;\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  align-items: center;\n  gap: ",
        "px;\n\n  ",
        " {\n    max-width: 305px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: ",
        "px;\n  flex-direction: column;\n  flex-grow: 1;\n  align-items: start;\n  gap: ",
        "px;\n  border-radius: 8px;\n  background: #f8f8f8;\n  margin-top: ",
        "px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-self: start;\n  flex-direction: column;\n  gap: ",
        "px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}














var OurServices = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)("food_program").t;
    var foodProgramCtaHref = (0,useFoodProgramCta/* useFoodProgramCta */.b)();
    var services = [
        {
            title: t("services.marketplace.title"),
            toWhom: t("services.marketplace.toWhom"),
            needs: t("services.marketplace.needs"),
            benefits: t("services.marketplace.benefits", {
                returnObjects: true
            }),
            image: notebook,
            cta: {
                text: t("services.marketplace.ctaText"),
                label: null,
                href: (0,urls/* marketplaceURL */.j5)("/catering"),
                primary: false
            }
        },
        {
            title: t("services.catering.title"),
            toWhom: t("services.catering.toWhom"),
            needs: t("services.catering.needs"),
            benefits: t("services.catering.benefits", {
                returnObjects: true
            }),
            image: smiling_person,
            cta: {
                text: t("services.catering.ctaText"),
                label: null,
                href: "/",
                primary: false
            }
        },
        {
            title: t("services.foodProgram.title"),
            toWhom: t("services.foodProgram.toWhom"),
            needs: t("services.foodProgram.needs"),
            benefits: t("services.foodProgram.benefits", {
                returnObjects: true
            }),
            image: catering_person,
            cta: {
                text: t("services.foodProgram.ctaText"),
                label: t("hero.ctaLabelBottom"),
                href: foodProgramCtaHref,
                primary: true
            }
        }, 
    ].map(function(service) {
        return Array.isArray(service.benefits) ? service : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, service), {
            benefits: []
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        as: "section"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                size: "sm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Utils/* FoodProgramH2 */.s, {
                    textAlign: "center",
                    mb: 6,
                    children: t("services.title")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                size: "md",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Services, {
                    children: services.map(function(param) {
                        var title = param.title, cta = param.cta, benefits = param.benefits, toWhom = param.toWhom, needs = param.needs, image = param.image;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Service, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IdeaImage, {
                                    src: image
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceTextSection, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                            alignSelf: "center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                                lineHeight: {
                                                    xs: 1.5,
                                                    sm: 1.5
                                                },
                                                fontSize: 20,
                                                alignSelf: "center",
                                                component: "h3",
                                                mb: 2,
                                                fontWeight: 600,
                                                children: title
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                            fontWeight: 600,
                                            children: t("services.labels.toWhom")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                            children: toWhom
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                            fontWeight: 600,
                                            children: t("services.labels.needs")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                            children: needs
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                            fontWeight: 600,
                                            children: t("services.labels.benefits")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitItems, {
                                            children: benefits.map(function(benefit) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                                                    alignSelf: "flex-start",
                                                    alignItems: "center",
                                                    display: "flex",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                                            flexShrink: 0,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                alt: "",
                                                                src: check_icon/* default */.Z,
                                                                layout: "fixed",
                                                                width: 25,
                                                                height: 19
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                                            fontSize: 16,
                                                            ml: 2,
                                                            children: benefit
                                                        })
                                                    ]
                                                }, benefit);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                    mt: 2,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                        rounded: true,
                                        target: "_blank",
                                        variant: cta.primary ? "primary" : "tertiary",
                                        component: "a",
                                        href: cta.href,
                                        children: cta.text
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                    children: cta.label || " ".replace(/ /g, "\xa0")
                                })
                            ]
                        }, title);
                    })
                })
            })
        ]
    }));
};
var StyledButton = (0,styled_components_browser_esm["default"])(esm.Button)(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(1.5, 4);
});
var Services = styled_components_browser_esm["default"].div(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(4);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("lg");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(9);
});
var Service = styled_components_browser_esm["default"].div(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("lg");
});
var ServiceTextSection = styled_components_browser_esm["default"].div(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
var IdeaImage = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        src: props.src,
        quality: 100,
        objectFit: "contain",
        alt: ""
    });
};
var BenefitItems = styled_components_browser_esm["default"].div(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.spacing(1);
});
/* harmony default export */ var foodProgram_OurServices = (OurServices);


/***/ })

}]);